import { render, staticRenderFns } from "./Championships.vue?vue&type=template&id=13183b96&"
import script from "./Championships.vue?vue&type=script&lang=js&"
export * from "./Championships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports